export { AtlProgressStepperItem } from './progress-stepper-item.component';
export { AtlProgressStepper } from './progress-stepper.component';
import { Sizes, StatusVariant } from './progress-stepper.props';

export * as ProgressStepperTags from './progress-stepper.tagnames';
export type * from './progress-stepper.props';
export * from './progress-stepper.events';

const ProgressStepperEnums = {
   StatusVariant,
   Sizes,
};

export { ProgressStepperEnums };
